import React from "react";
import GoDaddyPanel from "./GodaddyPanel";
import Typography from "@mui/material/Typography";
import UsersPanel from "./UsersPanel";

const AdminPanel = () => {
  return (
    <>
      <Typography variant="subtitle1" component="div">
        Users:
      </Typography>
      <UsersPanel />
      <br />
      <Typography variant="subtitle1" component="div">
        GoDaddy Accounts:
      </Typography>
      <GoDaddyPanel />
    </>
  );
};

export default AdminPanel;
